import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/budget/pages/Budget'
import { BudgetRoutePathsEnum } from '@/modules/budget/routes/budgetRouteConfig.types'

export const BUDGET_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: BudgetRoutePathsEnum.BUDGET,
  },
]
